import User from 'singletons/User'
import { Observer } from 'mobx-react-lite'
import cx from '@ui-components-3/ui/lib/utils/classNames'

const PaymentsAlert = () => {
  return (
    <Observer>
      {() => {
        const flag = User.getFeatureFlagByName('pwPaymentsAlert')
        if (flag && flag.text) {
          return (
            <div
              className={cx(
                'flex flex-col rounded-lg p-4 gap-4 text-white mx-6 mt-6',
                flag.type === 'alert' ? 'bg-red-500' : 'bg-primary',
              )}
              role="alert"
            >
              {flag.title ? <strong className="font-bold text-2xl">{flag.title}</strong> : null}
              <p className="block sm:inline">{flag.text}</p>
            </div>
          )
        }
        return null
      }}
    </Observer>
  )
}

export default PaymentsAlert
